import { useStoreActions, useStoreState } from '@discover-data/stores/restaurant/hooks';
import usePage from '@discover-data/stores/hooks/page/usePage';
import useRegularOnlyQueryState from './useQueryState';

export default function useRegularOnly(): [
  boolean,
  (newRegularOnly: boolean | null) => Promise<void>,
] {
  const storeMode = useStoreState((state) => state.mode);
  const storeValue = useStoreState((state) => state.regularOnly.value);
  const setStoreValue = useStoreActions((actions) => actions.regularOnly.set);
  const [, setRouterValue] = useRegularOnlyQueryState();
  const { resetPage } = usePage();

  async function set(newRegularOnly: boolean | null) {
    resetPage();

    setStoreValue(!!newRegularOnly);

    await setRouterValue(newRegularOnly);
  }

  return [storeValue, set];
}
